import Button from "./Button";

const AddButton = ({
  onClick,
  text,
  size,
  fill = true,
  isDisabled = false,
  style,
  icon = "plus",
}: any) => {
  return (
    <Button
      text={text}
      style={{ ...style }}
      type={fill ? "primary" : "secondary"}
      iconType={fill ? icon : ""}
      onClick={onClick}
      disabled={isDisabled}
    />
  );
};

export default AddButton;
